import React from 'react';
import { TextFieldProps, InputAdornment } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';


const DEFAULT_STYLE = {
    width: '100%',
    '& .MuiOutlinedInput-root': {
        borderRadius: '20px',
      },
}

type IconTextFieldProps = {
  onIconClick?: () => void;
  icon?: React.ReactNode;
  InputPropsStyle?:object;
} & Omit<TextFieldProps, "InputProps">;

export const IconTextField = ({
    icon,
    onIconClick,
    sx,
    InputPropsStyle,
  ...props
}: IconTextFieldProps): React.ReactElement => {
  return (
    <TextField
      sx={{ ...DEFAULT_STYLE, ...sx }}
      {...props}
      InputProps={{
        style: { ...InputPropsStyle },
        endAdornment: (
          <InputAdornment position="end" sx ={{ padding: '0px' }}>
            <IconButton onClick={onIconClick}>
              {icon}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
